<template>
  <div class="messaging-modal container flex">
    <div :class="{phone: mobile}" class="messaging-preview">
      <h1>Messages</h1>
      <h2>{{ currentUser.state.grade }} </h2>
      <p>{{ record.displayName }}</p>
      <div class="desktop-view">
        <div
          @click="toggleComposer"
          class="flex message-menu"
          :class="{active: showComposer}">
          <p class="chip">Compose</p>
          <PencilIcon class="icon"/>
        </div>
        <div
          @click="toggleInbox"
          class="flex message-menu"
          :class="{active: showInbox}">
          <p class="chip">Received</p>
          <MailIcon class="icon"/>
        </div>
        <div
          @click="toggleOutbox"
          class="flex message-menu"
          :class="{active: showOutbox}">
          <p class="chip">Sent</p>
          <InboxIcon class="icon"/>
        </div>
      </div>
      <div :class="{mobileview: mobile}" class="view-mobile">
        <compose-message
          v-if="showComposer"
          :messager="currentUser"
          @messagesent="toggleOutbox"
        />
        <mail-box
          v-if="showInbox"
          :messages="filteredInboxMessages"
          @messageDeleted="toggleInbox"
        />
        <mail-box
          v-if="showOutbox"
          :messages="filteredOutboxMessages"
          @messageDeleted="toggleOutbox"
        />
      </div>
    </div>
    <div :class="{mobile: mobile}" class="messaging-full">
      <compose-message
        v-if="showComposer"
        :messager="record"
        @messagesent="toggleOutbox"
      />
      <mail-box
        v-if="showInbox"
        :messages="filteredInboxMessages"
        @messageDeleted="toggleInbox"
      />
      <mail-box
        v-if="showOutbox"
        :messages="filteredOutboxMessages"
        @messageDeleted="toggleOutbox"
      />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'
import { inject, onMounted, ref, watchEffect } from 'vue'
import { MailIcon, PencilIcon, InboxIcon } from '@heroicons/vue/outline'
import ComposeMessage from '@/components/ComposeMessage.vue'
import MailBox from '@/components/MailBox.vue'

export default {
  props: ['record'],
  components: { MailIcon, PencilIcon, InboxIcon, ComposeMessage, MailBox },
  setup (props) {
    const filteredInboxMessages = ref(null)
    const filteredOutboxMessages = ref(null)
    const currentUser = inject('currentUser')
    const windowWidth = ref(null)
    const mobile = ref(false)
    const showComposer = ref(false)
    const showOutbox = ref(false)
    const showInbox = ref(true)
    const { myData, error, load } = getPosts()

    const toggleOutbox = () => {
      //  set toast to true('toasts')
      showOutbox.value = !showOutbox.value
      showComposer.value = false
      showInbox.value = false
      load(currentUser.state.grade + '/messages/' + currentUser.state.role)
    }

    const toggleInbox = () => {
      //  set toast to true('toasts')
      showInbox.value = !showInbox.value
      showOutbox.value = false
      showComposer.value = false
      load(currentUser.state.grade + '/messages/learner')
    }

    const toggleComposer = () => {
      showOutbox.value = false
      showInbox.value = false
      showComposer.value = !showComposer.value
    }

    load(currentUser.state.grade + '/messages/learner')

    watchEffect(() => {
      filteredInboxMessages.value =
        myData.value ? myData.value.filter(message => message.sender === props.record.displayName)
          : null
      filteredOutboxMessages.value =
        myData.value ? myData.value.filter(message => message.sender === currentUser.state.user.displayName)
          : null
    })

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 600) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { myData, error, currentUser, filteredOutboxMessages, filteredInboxMessages, toggleComposer, showComposer, toggleOutbox, toggleInbox, showOutbox, showInbox, mobile }
  }
}
</script>

<style>
.messaging-modal div {
  border: none !important;
}
.messaging-modal {
  min-height: 60vh;
  background: #f1f1f1;
  justify-content: space-around;
  padding: 8px 4px;
}
.messaging-preview {
  background: #fff;
  flex-basis: 35%;
}
.messaging-full {
  background: #ddd;
  flex-basis: 60%;
}
.messaging-modal .icon {
  width: 24px;
}
.message-menu {
  justify-content: space-between;
  cursor: pointer;
  margin: 6px;
  padding: 3px;
  transition: 0.5s ease-in-out all;
}
.message-menu:hover {
  background: #ddd;
}
.messaging-modal .active {
  background: rgba(14, 75, 62, 0.4);
}
.messaging-modal .phone {
  flex-basis: 85%;
}
.messaging-modal .mobile {
  display: none;
}
.messaging-modal .view-mobile {
  display: none;
}
.messaging-modal .mobileview {
  display: block;
  z-index: 3;
  margin-top: 30px;
}
</style>
